import { QueryClient } from '@tanstack/react-query';

// Single shared react-query client for the whole app.
//
// It lives here (rather than inline in index.tsx) so non-React modules — the
// axios interceptor in particular — can import the SAME instance and clear its
// cache on a forced logout. Without a shared handle, a session-expiry logout
// could not wipe cached server data and the next account to log in would see
// the previous account's dashboard until staleTime elapsed.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      // Treat data as fresh for 5 min so navigating between screens doesn't refetch
      // everything immediately (the default staleTime of 0 caused refetch storms).
      // Individual queries can still override this.
      staleTime: 5 * 60 * 1000
    }
  }
});

export default queryClient;
